import { gql } from "@apollo/client";

export const EARNED_SKILLS_QUERY = gql`
  fragment EarnedSkill on EarnedSkill {
    __typename
    earnedPointsSum
    id
    itemProgressEntryCount
    skill {
      __typename
      apiName
      id
      name
    }
  }

  query GetEarnedSkills(
    $trailblazerId: String
    $queryProfileById: Boolean!
    $slug: String
    $queryProfileBySlug: Boolean!
  ) {
    profileUser @client {
      isSelf @client
      id @client @export(as: "trailblazerId")
    }

    # Local State query for slug
    chassis @client {
      profile {
        username @export(as: "slug")
      }
      isSelf
    }

    # NOTE: it seems that when 'aliases' are used and resolved, the client side queries above are not executed anymore.

    profileById: profile(trailblazerId: $trailblazerId)
      @include(if: $queryProfileById) {
      __typename
      ... on PublicProfile {
        id
        earnedSkills {
          ...EarnedSkill
        }
      }
    }

    profileBySlug: profile(slug: $slug) @include(if: $queryProfileBySlug) {
      __typename
      ... on PublicProfile {
        id
        earnedSkills {
          ...EarnedSkill
        }
      }
    }
  }
`;
